import React from "react";
import PropTypes from "prop-types";
import {
  Clock,
  Globe,
  Link2,
  Shield,
  Flame,
  Target,
  Crosshair,
} from "lucide-react";

import { actionLabel } from "../../../../../utils/wafEventV3";
import { formatDate } from "../../../../../utils/format";
import {
  TEXT_PRIMARY,
  PRIMARY_COLOR,
  BLOCKED_STATUS_FG,
  drawerSeverityPalette,
  isBlockedAction,
} from "../wafEventDrawerShared";
import { EventAssessGrid } from "./smartParseDrawerUi";

export default function AssessmentPanel({ event }) {
  if (!event) return null;

  const { assessment, target, timestamp, primary_intent } = event;
  const severityPalette = drawerSeverityPalette(assessment?.severity);
  const actionColor = isBlockedAction(assessment?.action) ? BLOCKED_STATUS_FG : TEXT_PRIMARY;

  const cells = [
    {
      key: "timestamp",
      label: "Timestamp",
      value: timestamp ? formatDate(timestamp) : null,
      icon: Clock,
    },
    {
      key: "hostname",
      label: "Hostname",
      value: target?.host,
      icon: Globe,
      valueColor: PRIMARY_COLOR,
    },
    {
      key: "uri",
      label: "URI",
      value: target?.uri || target?.path,
      icon: Link2,
      monospace: true,
    },
    {
      key: "action",
      label: "Action",
      value: actionLabel(assessment?.action),
      icon: Shield,
      valueColor: actionColor,
    },
    {
      key: "severity",
      label: "Severity",
      value: severityPalette.label !== "—" ? severityPalette.label : null,
      icon: Flame,
      valueColor: severityPalette.fg,
    },
    {
      key: "attack_stage",
      label: "Attack stage",
      value: assessment?.attack_stage,
      icon: Target,
    },
    {
      key: "primary_intent",
      label: "Primary intent",
      value: primary_intent?.intent_name,
      icon: Crosshair,
    },
  ];

  return <EventAssessGrid cells={cells} />;
}

AssessmentPanel.propTypes = {
  event: PropTypes.object,
};
